import {
  currentOrPastMonthYearDateUI,
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateDateRange } from 'platform/shared/health-apps';
import DateRangeDescription from '../../../../components/FormDescriptions/DateRangeDescription';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['service-info--exposure-date-title'];
const DESC_TEXT = content['service-info--exposure-date-description'];
const INPUT_LABELS = {
  start: content['service-info--exposure-start-date-label'],
  end: content['service-info--exposure-end-date-label'],
};

const DEFAULT_OPTS = {
  hint: content['service-info--service-date-hint'],
  errorMessages: {
    pattern: content['validation-error--month-year-date-format'],
  },
};

const VALIDATIONS = [
  validateDateRange({
    startDateKey: 'toxicExposureStartDate',
    endDateKey: 'toxicExposureEndDate',
    monthYear: true,
    rangeErrorMessage: content['validation-error--exposure-date-range'],
  }),
];

const { toxicExposureStartDate, toxicExposureEndDate } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(DateRangeDescription),
    'view:toxicExposureDates': {
      toxicExposureStartDate: currentOrPastMonthYearDateUI({
        title: INPUT_LABELS.start,
        ...DEFAULT_OPTS,
      }),
      toxicExposureEndDate: currentOrPastMonthYearDateUI({
        title: INPUT_LABELS.end,
        ...DEFAULT_OPTS,
      }),
      'ui:validations': VALIDATIONS,
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:toxicExposureDates': {
        type: 'object',
        properties: {
          toxicExposureStartDate,
          toxicExposureEndDate,
        },
      },
    },
  },
};
